/**
 * B.H. Copyright (c) 2026 Yemot HaMashiach Ltd.
 * All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * Yemot HaMashiach Ltd. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with Yemot HaMashiach Ltd.
 *
 * Unauthorized copying of this file, via any medium, is strictly prohibited.
 */

// תבניות עיצוב למסך המשחק — לא רק צבע אלא צורת כל האלמנטים
// (רדיוסים, גבולות, צל, פונט, צורת תג המספר וכו').
// 'classic' זהה לחלוטין לעיצוב הקיים (קיר אבנים). מוסיפים 2 חלופות מובחנות.

const CLASSIC = {
  isImage: true, // רקע תמונת קיר האבנים (מטופל ב-GamePage)
  font: "'Poppins', sans-serif",
  accent: "rgba(199, 159, 28, 0.8)",
  accentSoft: "rgba(255, 217, 135, 0.32)",
  // פאנל השאלה
  qBg: "rgba(0, 0, 0, 0.4)",
  qBorder: "1px solid turquoise",
  qRadius: "15px",
  qBlur: "blur(8px)",
  qShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  qColor: "white",
  // כרטיס תשובה
  optBg: "rgba(255, 216, 131, 0.7)",
  optRadius: "5px",
  optShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  optText: "#222",
  optBorder: "none",
  // תג מספר התשובה
  badgeBg: "#bb571b",
  badgeRadius: "5px",
  badgeRotate: "45deg",
  // מונה שחקנים בתחתית הכרטיס + מסגרות משניות
  softBorder: "2px solid rgba(255, 216, 131, 0.7)",
  // גרף התוצאות (מסגרת + רקע)
  barBg: "linear-gradient(180deg, rgba(239, 225, 72, 0.6) 0%, rgba(73, 143, 235, 0.3) 100%)",
  barPctColor: "rgba(96, 64, 40, 0.9)",
  // שעון + תיבות סטטיסטיקה + סרגל כפתורים
  timerText: "white",
  statBg: "rgba(0, 0, 0, 0.6)",
  statBorder: "2px solid rgba(199, 159, 28, 0.8)",
  statText: "white",
  ctrlBarBg: "rgba(96, 64, 40, 0.9)",
  ctrlBtnBg: "rgba(150, 111, 51, 0.8)",
  ctrlHex: "rgba(255, 228, 196, 0.8)",
  ctrlText: "rgba(255, 228, 196, 0.95)",
  ctrlIconColor: "#fff",
  timerPath: "turquoise",
  timerTrail: "rgba(255, 216, 131, 0.3)",
  progressBorder: "brown",
  progressTrail: "rgba(255, 216, 131, 0.3)",
  pillBg: "rgba(150, 111, 51, 0.8)",
  // צבעי סקר (מותאמים לתבנית)
  surveyMain: "#667eea",
  surveySoft: "rgba(102, 126, 234, 0.5)",
};

const NEON = {
  isImage: false,
  pageBg:
    "radial-gradient(circle at 15% 15%, rgba(0,229,255,.12) 0%, transparent 40%)," +
    "radial-gradient(circle at 85% 85%, rgba(255,43,214,.12) 0%, transparent 42%)," +
    "linear-gradient(135deg,#070714 0%,#0d0d26 55%,#12122e 100%)",
  font: "'Assistant', 'Poppins', sans-serif",
  accent: "#00e5ff",
  accentSoft: "rgba(0, 229, 255, 0.12)",
  qBg: "rgba(10, 12, 32, 0.72)",
  qBorder: "2px solid #00e5ff",
  qRadius: "6px",
  qBlur: "blur(4px)",
  qShadow: "0 0 22px rgba(0, 229, 255, 0.45), inset 0 0 12px rgba(0,229,255,.15)",
  qColor: "#eafeff",
  optBg: "rgba(16, 20, 46, 0.9)",
  optRadius: "4px",
  optShadow: "0 0 18px rgba(0, 229, 255, 0.3)",
  optText: "#eafeff",
  optBorder: "2px solid rgba(0, 229, 255, 0.55)",
  badgeBg: "#00e5ff",
  badgeRadius: "3px",
  badgeRotate: "0deg",
  softBorder: "2px solid rgba(0, 229, 255, 0.55)",
  barBg: "linear-gradient(180deg, rgba(0,229,255,0.18) 0%, rgba(0,229,255,0.04) 100%)",
  barPctColor: "#eafeff",
  timerText: "#eafeff",
  statBg: "rgba(10, 12, 32, 0.75)",
  statBorder: "2px solid #00e5ff",
  statText: "#eafeff",
  ctrlBarBg: "linear-gradient(180deg, rgba(0,110,130,0.9) 0%, rgba(20,40,95,0.94) 55%, rgba(10,14,34,0.96) 100%)",
  ctrlBtnBg: "rgba(0, 229, 255, 0.22)",
  ctrlHex: "linear-gradient(135deg,#00e5ff 0%,#2f7bff 100%)",
  ctrlText: "#eafeff",
  ctrlIconColor: "#0a0c20",
  timerPath: "#00e5ff",
  timerTrail: "rgba(0, 229, 255, 0.15)",
  progressBorder: "#00e5ff",
  progressTrail: "rgba(0, 229, 255, 0.12)",
  pillBg: "#0891b2",
  surveyMain: "#00e5ff",
  surveySoft: "rgba(0, 229, 255, 0.22)",
};

const GLASS = {
  isImage: false,
  pageBg: "linear-gradient(135deg,#eef1ff 0%,#f4f0ff 40%,#fbf5ff 72%,#fef6fb 100%)",
  font: "'Poppins', sans-serif",
  accent: "#8b5cf6",
  accentSoft: "rgba(139, 92, 246, 0.10)",
  qBg: "rgba(255, 255, 255, 0.5)",
  qBorder: "1px solid rgba(255, 255, 255, 0.85)",
  qRadius: "28px",
  qBlur: "blur(18px)",
  qShadow: "0 16px 44px rgba(124, 92, 246, 0.16)",
  qColor: "#2e2a52",
  optBg: "rgba(255, 255, 255, 0.92)",
  optRadius: "24px",
  optShadow: "0 12px 30px rgba(124, 92, 246, 0.14)",
  optText: "#2e2a52",
  optBorder: "1px solid rgba(139, 92, 246, 0.16)",
  badgeBg: "linear-gradient(135deg,#8b5cf6,#c084fc)",
  badgeRadius: "50%",
  badgeRotate: "0deg",
  softBorder: "2px solid rgba(139, 92, 246, 0.22)",
  barBg: "linear-gradient(180deg, rgba(139,92,246,0.16) 0%, rgba(192,132,252,0.04) 100%)",
  barPctColor: "#5b21b6",
  timerText: "#6d28d9",
  statBg: "rgba(255, 255, 255, 0.7)",
  statBorder: "1px solid rgba(139, 92, 246, 0.28)",
  statText: "#2e2a52",
  ctrlBarBg: "rgba(255, 255, 255, 0.72)",
  ctrlBtnBg: "rgba(139, 92, 246, 0.16)",
  ctrlHex: "linear-gradient(135deg,#8b5cf6,#c084fc)",
  ctrlText: "#5b21b6",
  ctrlIconColor: "#fff",
  timerPath: "#8b5cf6",
  timerTrail: "rgba(139, 92, 246, 0.15)",
  progressBorder: "#8b5cf6",
  progressTrail: "rgba(139, 92, 246, 0.12)",
  pillBg: "#8b5cf6",
  surveyMain: "#8b5cf6",
  surveySoft: "rgba(139, 92, 246, 0.25)",
};

export const GAME_THEMES = [
  { id: "classic", name: "קיר אבנים", emoji: "🧱", tokens: CLASSIC },
  { id: "neon", name: "דרמטי", emoji: "🎮", tokens: NEON },
  { id: "glass", name: "פנינה", emoji: "", tokens: GLASS },
];

export const getTheme = (id) => GAME_THEMES.find((t) => t.id === id) || GAME_THEMES[0];
export const getTokens = (id) => getTheme(id).tokens;
